module.exports = "https://static.wmbcdn.com/uniweb/images/945d871f84d6d281b3c66da82d2d84b6.svg";